<!-- <div class="main-container"> -->
<!-- filters -->
<!-- country -->
<div class="filters">
  <div class="country">
    <div class="country-space" *ngIf="role != '3'">
      <ng-container
        *ngIf="initialCountryFlag && selectedCountry"
      ></ng-container>
      <input
        [ng2TelInputOptions]="initialCountryFlag"
        type="text"
        class="country-drop"
        (hasError)="hasError($event)"
        (intlTelInputObject)="telInputObject($event)"
        ng2TelInput
        (countryChange)="onCountryChange($event)"
        [value]="selectedCountry"
        onkeydown="return false"
      />
    </div>
    <div class="months">
      <div class="col">
        <div ngbDropdown class="d-inline-block">
          <button class="btn btn-custome" id="dropdownBasic1" ngbDropdownToggle>
            {{
              selectedFilterValue
                ? selectedFilterValue.displayName
                : ("page.filter" | translate)
            }}
          </button>
          <div ngbDropdownMenu aria-labelledby="dropdownBasic1">
            <button
              class="dropdown-item"
              *ngFor="let item of filterValues"
              (click)="onFilterValueChange(item)"
            >
              {{ item.displayName }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<!-- days -->
<ng-container *ngIf="role === '1' || role === '4'">
  <div class="section">
    <div class="col-lg-4 col-md-12">
      <div class="main-container">
        <div *ngIf="transactionData" class="sub-container">
          <div class="page-title">
            <span>{{ "page.transactionsummary" | translate }}</span>
          </div>
          <div class="topicwise">
            <span>{{ "page.transaction" | translate }}</span>
            <span class="value">{{ transactionData[0].value }}</span>
          </div>
          <div class="topicwise">
            <span>{{ "page.paid" | translate }}</span>
            <span class="value">{{ transactionData[1].value }}</span>
          </div>
          <div class="topicwise">
            <span>{{ "page.revenue" | translate }}</span>
            <span class="value">{{ transactionData[2].value }}</span>
          </div>
        </div>
      </div>
    </div>
    <div class="col-lg-8 col-md-12">
      <ng-container *ngIf="labelsBarChart && datasetBarChart">
        <app-bar-chart
          [datasetip]="datasetBarChart"
          [labelsip]="labelsBarChart"
          [legend]="true"
          [barChartTitle]="'page.count' | translate"
        ></app-bar-chart>
      </ng-container>
    </div>
  </div>
  <div class="col-lg-12 col-md-12 pa">
    <ng-container *ngIf="pageAnalyserSuperAdmin">
      <app-pa [data]="pageAnalyserSuperAdmin"></app-pa>
    </ng-container>
  </div>
  <div class="section">
    <div class="col-lg-6 col-md-12">
      <ng-container *ngIf="sendData.length > 0">
        <app-pie-chart
          [backgroundColorip]="bgColors"
          [dataip]="sendData"
          [labelsip]="sendlabels"
        >
        </app-pie-chart>
      </ng-container>
    </div>
    <div class="col-lg-6 col-md-12">
      <ng-container *ngIf="lineChartData"> </ng-container>
      <app-line-chart
        [barChartTitle]="'page.advertisements' | translate"
        [backgroundColorip]="bgColorsPieChart2"
        [dataip]="lineChartData"
        [labelsip]="lineChartLabelsip"
      >
      </app-line-chart>
    </div>
  </div>
</ng-container>
<ng-container *ngIf="role === '2' || role === '5'">
  <div class="main-container">
    <div class="col-lg-12 col-md-12 pa" *ngIf="pageAnalyserSpa">
      <app-pa [data]="pageAnalyserSpa"></app-pa>
    </div>
    <div class="section">
      <div class="col-lg-6 col-md-12">
        <ng-container *ngIf="SPAlabelsBarChart && SPAdatasetBarChart">
          <app-bar-chart
            [datasetip]="SPAdatasetBarChart"
            [labelsip]="SPAlabelsBarChart"
            [legend]="false"
            [barChartTitle]="'page.bookings' | translate"
          >
          </app-bar-chart>
        </ng-container>
      </div>
      <div class="col-lg-6 col-md-12">
        <!-- <app-pie2-chart [backgroundColorip]="bgColorsPieChart2" [dataip]="sendDataPieChart2"
            [labelsip]="sendlabelsPieChart2">
        </app-pie2-chart> -->

        <ng-container *ngIf="sendDataPolar && sendlabelsPolar">
          <app-polar-area-chart
            [backgroundColorip]="bgColorsPolar"
            [dataip]="sendDataPolar"
            [labelsip]="sendlabelsPolar"
            [polarTitle]="'page.servicerequests' | translate"
          >
          </app-polar-area-chart>
        </ng-container>
      </div>
    </div>
  </div>
</ng-container>

<ng-container *ngIf="role === '3'">
  <div class="section main-container">
    <div class="col-lg-6 col-md-12">
      <app-polar-area-chart
        [backgroundColorip]="AdbgColorsPolar"
        [dataip]="AdsendDataPolar"
        [labelsip]="AdsendlabelsPolar"
        [polarTitle]="'page.advertisements' | translate"
      >
      </app-polar-area-chart>
    </div>
    <div class="col-lg-6 col-md-12">
      <app-bar-chart
        *ngIf="AdSPAlabelsBarChart && AdSPAdatasetBarChart"
        [datasetip]="AdSPAdatasetBarChart"
        [labelsip]="AdSPAlabelsBarChart"
        [legend]="false"
        [barChartTitle]="'page.payments' | translate"
      >
      </app-bar-chart>
    </div>
  </div>
</ng-container>

<!-- </div> -->
